<template>
    <tenants :implementlevel="1"></tenants>
</template>
<script>
    import tenants from './TenantsManager'
    export default {
        data: function(){
            return {

            }
        },
        components: {
            tenants
        }
    }
</script>


// WEBPACK FOOTER //
// EnterpriseTenants.vue?f1d83684